import React from 'react';
import ReactDOM from 'react-dom/client';
import { loadableReady } from '@loadable/component';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { wrapHistory } from 'oaf-react-router';
import CmsConfiguration from '@exo/frontend-cms-config';
// import { DemoContextProvider } from './DemoContext';

import App from './App';
import applications from '../applications';

const history = createBrowserHistory();
wrapHistory(history);

if (window !== 'undefined' && window.Cypress) {
  // eslint-disable-next-line no-underscore-dangle
  window._exoHistory = history;
}

const promises = [];

// In certain environments (AEM) all loadable components must be loaded up-front
if (process.env.PRELOAD_ALL) {
  promises.push(
    ...(applications?.cms?.components || [])
      .filter(c => c?.component?.load)
      .map(c => c.component.load())
  );
}

// Again, some CMSs, require additional promises to resolve before the app loads
if (CmsConfiguration?.allPromises) {
  promises.push(...(CmsConfiguration.allPromises() ?? []));
}

Promise.all(promises).then(() => {
  loadableReady(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      // <DemoContextProvider config={applications}>
      <Router history={history}>
        <App config={applications} />
      </Router>
      // </DemoContextProvider>
    );
  });
});
